<script>
import VueSelect from "vue-select";
import {useModal} from "vue-final-modal";
import Modal from "$vueCommon/components/Modal.vue";
import DnsProfileAddEdit from "$vueCommon/components/Cart/DnsProfileAddEdit.vue";
import CheckoutAPI from "$vueCommon/classes/API/CheckoutAPI.js";

export default {
    components: {
        VueSelect
    },
    props: {
        domain: Object,
        dnsProfiles: Array,
        selectedDnsProfileId: Number,
        onDismiss: Function,
        onConfirm: Function
    },
    mounted() {
        this.setSelectedDnsProfile();
    },
    data() {
        return {
            selectedDnsProfile: null,
            localSelectedDnsProfile: null,
            testy: null,
            sameDnsProfiles: true,
            savingDnsProfile: false
        }
    },
    computed: {
        dnsProfilesList() {
            if (!Array.isArray(this.dnsProfiles)) {
                return [];
            }

            return this.dnsProfiles.map(dnsProfile => {
                dnsProfile.label = `${dnsProfile.name} (${dnsProfile.dns_1}, ${dnsProfile.dns_2})`;

                return dnsProfile;
            });
        }
    },
    methods: {
        setSelectedDnsProfile() {
            for (const dnsProfile of this.dnsProfiles) {
                if (dnsProfile.id === this.selectedDnsProfileId) {
                    this.localSelectedDnsProfile = dnsProfile;
                }
            }
        },
        editDnsProfile(dnsProfile = {}) {
            let that = this;
            const {open, close} = useModal({
                component: Modal,
                attrs: {
                    title: this.$translate('checkout.edit_dns_profile'),
                    size: 'md',
                    onConfirm() {
                        close();
                    }
                },
                slots: {
                    default: {
                        component: DnsProfileAddEdit,
                        attrs: {
                            dnsProfile: dnsProfile,
                            onConfirm: function (r) {
                                close();
                                that.setSelectedDnsProfile();
                            },
                            onDismiss: function() {
                                close();
                            }
                        }
                    }
                }
            });
            open();
        },
        saveDnsProfile() {
            this.savingDnsProfile = true;
            CheckoutAPI.postUserDomainDnsProfile(this.domain.rowId, this.localSelectedDnsProfile).then(response => {
                this.savingDnsProfile = false;
                this.onConfirm({dnsProfile: this.localSelectedDnsProfile, sameDnsProfiles: this.sameDnsProfiles})
            })
        }
    }
}
</script>
<template>
    <div class="component-domain-item-dns-profile">
        <h4>{{ $translate('checkout.dns_profile') }}</h4>
        <vselect :options="dnsProfilesList" v-model="localSelectedDnsProfile"
                 :clearable="false" :searchable="false">
            <template v-slot:option="option">
                <span>{{ option.label }}</span>
                <button v-if="option.user_id" @click.stop="editDnsProfile(option)" class="btn btn-sm">{{ $translate('checkout.edit') }}</button>
            </template>
            <template v-slot:list-footer="footer">
                <button @click="editDnsProfile()" class="btn btn-sm">{{ $translate('checkout.add_dns_profile') }}</button>
            </template>
        </vselect>
        <div class="pretty p-default p-primary mt-4">
            <input type="checkbox" v-model="sameDnsProfiles" id="sameDnsProfiles" name="sameDnsProfiles">
            <div class="state p-primary">
                <label for="sameDnsProfiles">{{ $translate('checkout.use_same_dns_profiles_for_other_domains') }}</label>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-6">
                <button class="btn btn-circle w-100" @click="onDismiss()">{{ $translate('checkout.cancel') }}</button>
            </div>
            <div class="col-6">
                <button class="btn btn-primary w-100" @click="saveDnsProfile" :class="{disabled: savingDnsProfile}">
                    <template v-if="!savingDnsProfile">{{ $translate('checkout.apply') }}</template>
                    <template v-if="savingDnsProfile">
                        <span class="vue-loader"></span>
                    </template>
                </button>
            </div>
        </div>
    </div>
</template>
